import { useBoundValue } from "lib/@components/binding/use-bound-value.js"
import { StandardAutocomplete } from "lib/@components/binding/bound-components.js"
import { Stack, Typography } from "@mui/material"
import { toDataCy } from "lib/to-data-cy.js"
import { FACILITY_TYPES } from "routes/asset-register/plugins/asset-mapping/constants.js"

const FACILITY_TYPES_OPTIONS = Object.values(FACILITY_TYPES)

export function MappingSettingsFacilityType() {
    const [healthcare, setHealthcare] = useBoundValue("healthcare", false)
    const [mothballing, setMothballing] = useBoundValue("mothballing", false)
    const [reactivation, setReactivation] = useBoundValue("reactivation", false)

    const selectedFacilityTypes = [
        healthcare && FACILITY_TYPES.healthcare,
        mothballing && FACILITY_TYPES.mothballing,
        reactivation && FACILITY_TYPES.reactivation,
    ].filter(Boolean)

    return (
        <Stack spacing={2}>
            <StandardAutocomplete
                options={FACILITY_TYPES_OPTIONS}
                onChange={setFacilityTypes}
                value={selectedFacilityTypes}
                data-cy="mapping-facility-type"
                multiple
                label="Facility Type"
                renderOption={renderOption}
            />
        </Stack>
    )

    function setFacilityTypes(_, value) {
        setHealthcare(value.includes(FACILITY_TYPES.healthcare))
        setMothballing(value.includes(FACILITY_TYPES.mothballing))
        setReactivation(value.includes(FACILITY_TYPES.reactivation))
    }

    function renderOption(props, option) {
        return (
            <li {...props} data-cy={`${toDataCy("mapping-facility-type", option)}`}>
                <Typography component="span">{option}</Typography>
            </li>
        )
    }
}
